<template>
    <div class="container">
        <div class="box-title">
            <h4>
                <i class="fal fa-money-bill-wave"></i>
                ຂໍ້ມູນ ລາຄາຂົນສົ່ງ ( Shipping Rates )
                <span class="countTotal">({{ pagination.total || 0 }})</span>
                <span class="btn-add">
                    <vs-button circle icon flat @click="OpenModalAdd()">
                        <i class="fal fa-plus-circle"></i>
                    </vs-button>
                </span>
            </h4>
        </div>

        <div class="box">
            <div class="columns">
                <div class="column is-3">
                    <div class="control">
                        <label class="label">ປະເພດການຂົນສົ່ງ</label>
                        <div class="select">
                            <select v-model="filterTransportType" @change="ResetPageAndFetch()">
                                <option value="">ທັງໝົດ</option>
                                <option v-for="(t, i) in transportTypes" :key="i" :value="t.id">{{ t.name }}</option>
                            </select>
                        </div>
                    </div>
                </div>
                <div class="column is-3">
                    <div class="control">
                        <label class="label">ປະເທດປາຍທາງ</label>
                        <div class="select">
                            <select v-model="filterAddressCountry" @change="ResetPageAndFetch()">
                                <option value="">ທັງໝົດ</option>
                                <option v-for="(c, i) in addressCountries" :key="i" :value="c.id">{{ c.name }}</option>
                            </select>
                        </div>
                    </div>
                </div>
                <div class="column is-2">
                    <div class="control">
                        <label class="label">ຈຳນວນຕໍ່ໜ້າ</label>
                        <div class="select">
                            <select v-model.number="per_page" @change="ResetPageAndFetch()">
                                <option :value="15">15</option>
                                <option :value="25">25</option>
                                <option :value="50">50</option>
                                <option :value="100">100</option>
                            </select>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <div class="center">
            <vs-table>
                <template #thead>
                    <vs-tr>
                        <vs-th>ລຳດັບ</vs-th>
                        <vs-th>ປະເພດການຂົນສົ່ງ</vs-th>
                        <vs-th>ປະເທດປາຍທາງ</vs-th>
                        <vs-th>ລາຄາ ( Shipping Rates )</vs-th>
                        <vs-th>ສູດຄິດໄລ່ນ້ຳໜັກ</vs-th>
                        <vs-th></vs-th>
                    </vs-tr>
                </template>
                <template #tbody>
                    <vs-tr :key="index" :data="rate" v-for="(rate, index) in rates">
                        <vs-td>{{ pagination.from ? pagination.from + index : index + 1 }}</vs-td>
                        <vs-td>{{ transportLabel(rate.transport_type) }}</vs-td>
                        <vs-td>{{ countryLabel(rate.address_country) }}</vs-td>
                        <vs-td>{{ rate.shipping_rates }}</vs-td>
                        <vs-td>{{ rate.volumetric_weight_formula }}</vs-td>
                        <vs-td style="text-align: right; width: 100px">
                            <div class="group-icon">
                                <vs-button circle icon flat @click="OpenModalEdit(rate.id)">
                                    <i class="fad fa-pencil-alt"></i>
                                </vs-button>
                                <vs-button circle danger icon flat @click="OpenModalDelete(rate.id)">
                                    <i class="fad fa-trash-alt"></i>
                                </vs-button>
                            </div>
                        </vs-td>
                    </vs-tr>
                </template>
                <template #footer>
                    <pagination
                        v-if="pagination.last_page > 1"
                        :pagination="pagination"
                        :offset="offset"
                        @paginate="FetchData()"
                    />
                    <Loading v-if="isLoading"/>
                </template>
            </vs-table>
        </div>

        <ModalAdd>
            <template v-slot="{ close }">
                <AddShippingRate @close="close" @success="FetchData()"/>
            </template>
        </ModalAdd>

        <ModalEdit>
            <template v-slot="{ close }">
                <EditShippingRate :shippingRate="filterShippingRate" @close="close" @success="FetchData()"/>
            </template>
        </ModalEdit>

        <ModalDelete>
            <template v-slot="{ close }">
                <DeleteShippingRate :shippingRateId="shippingRateId" @close="close" @success="FetchData()"/>
            </template>
        </ModalDelete>
    </div>
</template>

<script>
import Loading from '../../Loading';
import pagination from '../../../Plugins/Paginations/Pagination';
import AddShippingRate from './Dialog/Add';
import EditShippingRate from './Dialog/Edit';
import DeleteShippingRate from './Dialog/Delete';

export default {
    components: {
        Loading,
        pagination,
        AddShippingRate,
        EditShippingRate,
        DeleteShippingRate,
    },
    data: () => ({
        isLoading: true,
        rates: [],
        filterShippingRate: {},
        shippingRateId: '',

        filterTransportType: '',
        filterAddressCountry: '',

        // Pagination
        offset: 10,
        per_page: 15,
        pagination: {},

        transportTypes: [
            { id: 'normal', name: 'ປົກກະຕິ ( Normal )' },
            { id: 'air_freight', name: 'ທາງຍົນ ( Air Freight )' },
            { id: 'railway', name: 'ທາງລົດໄຟ ( Railway )' },
        ],
        addressCountries: [
            { id: 'zh', name: 'ຈີນ ( ZH )' },
            { id: 'th', name: 'ໄທ ( TH )' },
        ],
    }),
    methods: {
        transportLabel(id) {
            const item = this.transportTypes.find(t => t.id === id);
            return item ? item.name : id;
        },
        countryLabel(id) {
            const item = this.addressCountries.find(c => c.id === id);
            return item ? item.name : id;
        },
        OpenModalAdd() {
            this.$store.commit('modalAdd_State', true);
        },
        OpenModalEdit(id) {
            this.filterShippingRate = { ...this.FilterItem(id) };
            this.$store.commit('modalEdit_State', true);
        },
        OpenModalDelete(id) {
            this.shippingRateId = id;
            this.$store.commit('modalDelete_State', true);
        },
        FilterItem(id) {
            return this.rates.filter(item => item.id === id)[0] || {};
        },
        ResetPageAndFetch() {
            this.pagination.current_page = 1;
            this.FetchData();
        },
        FetchData() {
            this.isLoading = true;
            const params = { page: this.pagination.current_page || 1, per_page: this.per_page };
            if (this.filterTransportType) params.transport_type = this.filterTransportType;
            if (this.filterAddressCountry) params.address_country = this.filterAddressCountry;

            this.$http.get('shipping-rate', { params }).then(res => {
                const payload = res.data ? res.data.data : null;
                setTimeout(() => { this.isLoading = false; }, 200);
                setTimeout(() => {
                    let rows = [];
                    let meta = {};
                    if (Array.isArray(payload)) {
                        // Flat array response — no pagination wrapper
                        rows = payload;
                        meta = {
                            current_page: 1,
                            last_page: 1,
                            per_page: this.per_page,
                            from: rows.length ? 1 : 0,
                            to: rows.length,
                            total: rows.length,
                        };
                    } else if (payload && Array.isArray(payload.data)) {
                        // Laravel paginator shape
                        rows = payload.data;
                        meta = payload.meta || {};
                    }
                    this.rates = rows;
                    this.pagination = {
                        current_page: meta.current_page || 1,
                        last_page: meta.last_page || 1,
                        per_page: meta.per_page || this.per_page,
                        from: meta.from || 0,
                        to: meta.to || 0,
                        total: meta.total || rows.length,
                    };
                }, 100);
            }).catch(() => {
                this.isLoading = false;
            });
        },
    },
    created() {
        this.FetchData();
    },
};
</script>

<style lang="scss" scoped>
.container {
    margin-top: 40px;

    .title-login {
        font-size: 20px;
        color: $primary-color;
    }

    @media screen and (max-width: 768px) {
        .columns {
            flex-direction: column;
        }
    }
}
</style>
